<template>
    <div>
        <div class="row">
            <div class="col-lg-4">
                <div class="form-group">
                    <label class="control-label">CEP</label>
                    <input type="text" class="form-control" :disabled="disable" v-model="address.zip_code" @keyup="searchZipCode" v-mask="'#####-###'" placeholder="_____-___">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <label class="control-label">Estado</label>
                    <select class="form-control" :disabled="disable" v-model="address.state_id" @change="address.city_id=null">
                        <option :value="null">Selecione um estado</option>
                        <option v-for="(state, index) in optionsStates" :key="'states_'+index" :value="state.value">{{state.text}}</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group">
                    <label class="control-label">Cidade</label>
                    <select class="form-control" :disabled="disable" v-model="address.city_id">
                        <option :value="null">Selecione uma cidade</option>
                        <option v-for="(state, index) in optionsCity" :key="'cities_'+index" :value="state.value">{{state.text}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-2">
                <div class="form-group">
                    <label class="control-label">Logradouro</label>
                    <select class="form-control" :disabled="disable" v-model="address.logradouro">
                        <option :value="null">Nenhum</option>
                        <option value="Rua">Rua</option>
                        <option value="Avenida">Avenida</option>
                        <option value="Rodovia">Rodovia</option>
                        <option value="Estrada">Estrada</option>
                        <option value="Lote">Lote</option>
                        <option value="Servidão">Servidão</option>
                        <option value="Quadra">Quadra</option>
                        <option value="Travessa">Travessa</option>
                        <option value="Linha">Linha</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group required">
                    <label>Endereço</label>
                    <input type="text" class="form-control" placeholder="Endereço" :disabled="disable" v-model="address.street">
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group required">
                    <label>Número</label>
                    <input type="number" class="form-control" placeholder="S/N" :disabled="disable" v-model="address.number">
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-group required">
                    <label>Bairro</label>
                    <input type="text" :disabled="disable" v-model="address.neighborhood" class="form-control" placeholder="Bairro">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <label>Complemento</label>
                    <input type="text" :disabled="disable" v-model="address.complement" class="form-control" placeholder="Complemento">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {TheMask} from 'vue-the-mask'

    export default {
        name: "AddressForm",

        components: { TheMask },

        props: {
            disable: { type: Boolean, default: false },
            addressProp: { type: Object, default: () => { return {
                        street: null,
                        logradouro: null,//string nullable
                        number: null,
                        complement: null,
                        neighborhood: null,
                        zip_code: null,
                        observation: null,
                        type:'res',
                        city_id: null,
                        state_id: null,
                    }
                }
            },
        },

        data() {
            return {
                optionsToast: { timeout: 6000, position: "topCenter" },
                optionsStates:[],
                optionsCity:[],

                address: this.addressProp,
            }
        },

        async mounted() {
            //preenchendo o select dos estados para o local de nascimento do aluno
            try {
                const response = await axios.get('/get-states/1');
                for (let k in response.data.data)
                    this.optionsStates.push({ value: response.data.data[k].id, text: response.data.data[k].state });
            } catch (error) {
                console.log(error);
            }
            if(this.address.type === '' || !this.address.type)//em aguns casos antigos, o endereço pode vir com o type vazio
                this.address.type = 'res'
        },

        computed: {
            stateComputed() {
                return this.address.state_id;
            }
        },

        watch: {
            address: {
                handler: function (address) {
                    this.$emit('address', address)
                },
                deep: true
            },
            
            async stateComputed(){
                await this.fillCity(this.address.city_id)
            }
        },

        methods: {
            async searchZipCode() {
                if(this.address.zip_code){
                    this.address.zip_code = this.address.zip_code.trim().replace(/[^0-9]/g, '');
                    if(this.address.zip_code.length == 8) {
                        let self = this
                        $.getJSON("https://viacep.com.br/ws/"+ this.address.zip_code +"/json/?callback=?", async function(dados) {
                            if(!dados.erro){
                                self.address.neighborhood = dados.bairro
                                self.address.complement = dados.complemento

                                //abaixo testo a primeira palavra da rua (logradouro), se existir removo da rua e seleciono o logradouro
                                let rua = /Rua /i;
                                let avenida = /Avenida /i;
                                let rodovia = /Rodovia /i;
                                let estrada = /Estrada /i;
                                let lote = /Lote /i;
                                let servidao = /Servidão /i;
                                let quadra = /Quadra /i;
                                let travessa = /Travessa /i;
                                let linha = /Linha /i;

                                if(rua.test(dados.logradouro)) {
                                    self.address.logradouro = 'Rua'
                                    let regEx = new RegExp('Rua ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(avenida.test(dados.logradouro)){
                                    self.address.logradouro = 'Avenida'
                                    let regEx = new RegExp('Avenida ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(rodovia.test(dados.logradouro)){
                                    self.address.logradouro = 'Rodovia'
                                    let regEx = new RegExp('Rodovia ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(estrada.test(dados.logradouro)){
                                    self.address.logradouro = 'Estrada'
                                    let regEx = new RegExp('Estrada ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(lote.test(dados.logradouro)){
                                    self.address.logradouro = 'Lote'
                                    let regEx = new RegExp('Lote ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(servidao.test(dados.logradouro)){
                                    self.address.logradouro = 'Servidão'
                                    let regEx = new RegExp('Servidão ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(quadra.test(dados.logradouro)){
                                    self.address.logradouro = 'Quadra'
                                    let regEx = new RegExp('Quadra ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(travessa.test(dados.logradouro)){
                                    self.address.logradouro = 'Travessa'
                                    let regEx = new RegExp('Travessa ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else if(linha.test(dados.logradouro)){
                                    self.address.logradouro = 'Linha'
                                    let regEx = new RegExp('Linha ', "ig");
                                    self.address.street = dados.logradouro.replace(regEx, '')
                                } else {
                                    self.address.street = dados.logradouro
                                }

                                self.address.city = dados.localidade
                                let s = await axios.get('/get-states/1')
                                const state = s.data.data.find(x => x.initials === dados.uf)
                                self.address.state_id = state.id
                                await self.fillCity(dados.localidade)
                            } else {
                                self.$toast.warning("CEP não encontrado.", "Aviso", self.optionsToast);
                            }
                        });
                    }
                }
            },


            async fillCity(city = null){
                this.optionsCity = []
                // this.address.city_id = null
                if(this.address.state_id){
                    try {
                        const response = await axios.get('/get-cities/'+this.address.state_id);
                        for (let k in response.data.data){
                            this.optionsCity.push({ value: response.data.data[k].id, text: response.data.data[k].city });
                        }
                        if(city){
                            if(isNaN(city)){
                                const ct = response.data.data.find(x => x.city == city)
                                this.address.city_id = ct.id
                            }else{
                                this.address.city_id = city
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            },

            resetAddress(){
                this.address = {
                    street: null,
                    logradouro: null,//string nullable
                    number: null,
                    complement: null,
                    neighborhood: null,
                    zip_code: null,
                    observation: null,
                    type:'res',
                    city_id: null,
                    state_id: null,
                }
            }
        },
    }
</script>

<style>

</style>